module.exports = __webpack_public_path__ + "img/ap32-landing-text1.4e13f81f.png";